/* WaterFun desktop dropdown menu (client request 2026-09-29).
 *
 * Parent items in Dawn's dropdown menu are <summary> toggles, so clicking
 * them only opened the list. Now, on devices with a real mouse:
 *   - hovering a parent opens its dropdown (closes shortly after leaving);
 *   - CLICKING a parent goes to data-wf-href, set in
 *     snippets/header-dropdown-menu.liquid to its first sub-category
 *     collection (or the parent's own page when it has none).
 * Keyboard users keep Dawn's behavior (Enter/Space opens the list - a
 * keyboard "click" has event.detail === 0), and touch screens keep
 * tap-to-open, since they cannot hover to reveal the list.
 *
 * Listeners are delegated from the document, so they survive Dawn
 * re-rendering the header.
 */
(function () {
  'use strict';
  if (window.wfHeaderMenuInit) return;
  window.wfHeaderMenuInit = true;

  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var CLOSE_DELAY = 180; /* ms: lets the pointer cross the gap into the list */

  function menuDetails(el) {
    return el && el.closest ? el.closest('.header__inline-menu details') : null;
  }

  /* Click: capture phase, so the native <details> toggle and Dawn's own
     handlers never see a mouse click on a parent that has a destination. */
  document.addEventListener(
    'click',
    function (event) {
      if (!finePointer.matches || event.detail === 0) return;
      var summary = event.target.closest('.header__inline-menu summary[data-wf-href]');
      if (!summary) return;
      event.preventDefault();
      event.stopPropagation();
      window.location.href = summary.getAttribute('data-wf-href');
    },
    true
  );

  /* Hover open / delayed close. mouseover/mouseout bubble (mouseenter does
     not), which keeps this delegated. */
  document.addEventListener('mouseover', function (event) {
    if (!finePointer.matches) return;
    var details = menuDetails(event.target);
    if (!details) return;
    clearTimeout(details._wfCloseTimer);
    if (!details.hasAttribute('open')) details.setAttribute('open', '');
  });

  document.addEventListener('mouseout', function (event) {
    if (!finePointer.matches) return;
    var details = menuDetails(event.target);
    if (!details) return;
    /* Still inside the same menu item (e.g. moving into its list). */
    if (event.relatedTarget && details.contains(event.relatedTarget)) return;
    clearTimeout(details._wfCloseTimer);
    details._wfCloseTimer = setTimeout(function () {
      details.removeAttribute('open');
    }, CLOSE_DELAY);
  });
})();
